import React from 'react';
export function Footer() {
  return <>
      <footer className="py-12 bg-green-50 rounded-lg mt-12" data-id="element-75">
        <div className="max-w-3xl mx-auto text-center" data-id="element-76">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 mb-8" data-id="element-77">
            Ready to Begin?
          </h2>
          <p className="text-xl mb-6" data-id="element-78">
            If you're feeling the pull — to try something different
          </p>
          <p className="text-xl mb-6" data-id="element-79">
            Something ancient, yet surprisingly gentle
          </p>
          <p className="text-xl mb-6" data-id="element-80">
            Something that works with your body, not against it…
          </p>
          <p className="text-xl font-bold mb-6" data-id="element-81">
            Aya Caps might be the missing piece.
          </p>
          <p className="text-xl mb-6" data-id="element-82">Not a quick fix.</p>
          <p className="text-xl mb-6" data-id="element-83">Not a magic bullet.</p>
          <p className="text-xl mb-6" data-id="element-84">
            But a steady, sacred ally in your daily rhythm.
          </p>
          <p className="text-xl mb-6" data-id="element-85">
            Thousands of people are already integrating this plant into their
            wellness journey.
          </p>
          <p className="text-xl mb-8" data-id="element-86">Now, it's your turn.</p>
          <div className="flex justify-center" data-id="element-87">
            <a href="https://tryayacaps.com/products/buy-3-aya-caps-get-3-free-ayahuasca-vine-microdoses-180-servings" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg text-xl transition duration-300 shadow-lg" data-id="element-88">
              Try Aya Caps Today
            </a>
          </div>
        </div>
      </footer>
      <div className="bg-gray-100 py-10" data-id="element-89">
        <div className="max-w-5xl mx-auto px-4" data-id="element-90">
          <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-91">
            <div data-id="element-92">
              <h3 className="text-lg font-bold mb-4 text-gray-700" data-id="element-93">
                Important Information
              </h3>
              <div className="text-sm text-gray-600" data-id="element-94">
                <p className="mb-4" data-id="element-95">
                  † This product contains Banisteriopsis caapi, which is a
                  natural Monoamine Oxidase Inhibitor (MAOI). Before taking this
                  supplement, please consult with your healthcare provider,
                  especially if you are taking any other medications, as MAOIs
                  can interact with certain drugs, including antidepressants and
                  certain pain medications.
                </p>
                <p data-id="element-96">
                  These statements have not been evaluated by the Food and Drug
                  Administration. This product is not intended to diagnose,
                  treat, cure, or prevent any disease.
                </p>
              </div>
            </div>
            <div data-id="element-97">
              <h3 className="text-lg font-bold mb-4 text-gray-700" data-id="element-98">Policies</h3>
              <ul className="space-y-2 text-sm" data-id="element-99">
                <li data-id="element-100">
                  <a href="https://tryayacaps.com/policies/refund-policy" className="text-green-700 hover:text-green-900 hover:underline" data-id="element-101">
                    Refund Policy
                  </a>
                </li>
                <li data-id="element-102">
                  <a href="https://tryayacaps.com/policies/privacy-policy" className="text-green-700 hover:text-green-900 hover:underline" data-id="element-103">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-104">
                  <a href="https://tryayacaps.com/policies/terms-of-service" className="text-green-700 hover:text-green-900 hover:underline" data-id="element-105">
                    Terms of Service
                  </a>
                </li>
                <li data-id="element-106">
                  <a href="https://tryayacaps.com/policies/shipping-policy" className="text-green-700 hover:text-green-900 hover:underline" data-id="element-107">
                    Shipping Policy
                  </a>
                </li>
                <li data-id="element-108">
                  <a href="https://tryayacaps.com/policies/contact-information" className="text-green-700 hover:text-green-900 hover:underline" data-id="element-109">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-300 pt-6 text-center" data-id="element-110">
            <p className="text-sm text-gray-500" data-id="element-111">
              © {new Date().getFullYear()} Aya Caps. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>;
}